export const calendlyLink =
  'https://calendly.com/jaime-jaimesimsmcbride/coaching-consultation'
